import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import IconButton from '../IconButton/IconButton';
import LabelText from '../LabelText/LabelText';

import './LikeButtonWrapper.css';

/**
 * Component holding the like button
 * and the likes counter (if there is at least one like)
 */
const LikeButtonWrapper = ({
  handleLikeButtonClick,
  isLikedByUser,
  likesCount
}) => {
  return (
    <>
      <IconButton
        label={i18next.t('like')}
        baseIcon={['fal', 'thumbs-up']} // outline icon
        activatedIcon={['fas', 'thumbs-up']} // filled in icon
        onClick={handleLikeButtonClick}
        isActivated={isLikedByUser}
      />
      <div styleName="likes-count-container">
        {likesCount > 0 && <LabelText text={likesCount} />}
      </div>
    </>
  );
};

LikeButtonWrapper.propTypes = {
  handleLikeButtonClick: PropTypes.func.isRequired,
  likesCount: PropTypes.number.isRequired, // Will be 0 if comment is not liked
  isLikedByUser: PropTypes.bool.isRequired
};

export default LikeButtonWrapper;
